import { render, staticRenderFns } from "./TaskTip.vue?vue&type=template&id=2745cc30&scoped=true&"
import script from "./TaskTip.vue?vue&type=script&lang=js&"
export * from "./TaskTip.vue?vue&type=script&lang=js&"
import style0 from "./TaskTip.vue?vue&type=style&index=0&id=2745cc30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745cc30",
  null
  
)

export default component.exports